module.exports = __webpack_public_path__ + "static/zon-the-go1-ee1de97a8314aaffd53f288a4c23de39.png";